export default __webpack_public_path__ + "static/media/UserSelection.41d4894d.svg";